import { arrayCount, hasProperty, nullToEmpty } from "@/js/utils";
import { SaveType } from "@/js/value-objects/save-type";
import { FacilityClass } from "@/js/value-objects/facility-class";
import config from "@/js/const";
import moment from "moment";

export class EvaFacilityStatusTranslator {
  /**
   * 現在の避難者数取得（避難者数 - 退所者数）
   * @param facility
   * @returns {number}
   */
  static currentSeatingCapacity(facility) {
    const capacity = EvaFacilityStatusTranslator.toNumber(
      facility,
      "seating_capacity"
    );
    const exit = EvaFacilityStatusTranslator.toNumber(facility, "exit_num");
    return capacity - exit;
  }

  /**
   * QRコード情報取得
   * @param facilityEvaInfo
   * @param facilityId
   * @returns {{exitCount: number, enterCount: number}}
   */
  static qrInfo(facilityEvaInfo, facilityId) {
    let enterCount = 0;
    let exitCount = 0;
    if (arrayCount(facilityEvaInfo) > 0) {
      const facility = facilityEvaInfo.find(info => {
        return info.fa_id === facilityId;
      });
      if (facility) {
        enterCount = facility.enter_count;
        exitCount = facility.exit_count;
      }
    }
    return {
      enterCount,
      exitCount
    };
  }

  /**
   * 数値に変換
   * ※変換不可の場合「0」を返す
   * TODO: 上記の動きは正しい？
   * @param obj
   * @param key
   * @returns {number}
   */
  static toNumber(obj, key) {
    if (hasProperty(obj, key)) {
      const value = Number(obj[key]);
      if (!isNaN(value)) {
        return value;
      }
    }
    return 0;
  }

  static toPayload(disasterNo, editedItem, saveType, bulkEditItem = {}) {
    if (!(saveType instanceof SaveType)) {
      throw new Error(`引数不正 [saveType=${saveType}]`);
    }
    const facilityClass = FacilityClass.factory(editedItem.facility_class);
    const payload = {
      fa_id: editedItem.fa_id,
      disaster_no: disasterNo,
      opening_status: nullToEmpty(editedItem.opening_status),
      opening_date: EvaFacilityStatusTranslator.formatDatetime(
        editedItem.opening_date
      ),
      closing_date: EvaFacilityStatusTranslator.formatDatetime(
        editedItem.closing_date
      ),
      hash: editedItem.hash
    };

    /**
     * 更新
     */
    if (saveType.isUpdate()) {
      // 避難所
      if (facilityClass.isShelter()) {
        Object.assign(payload, {
          electricity: nullToEmpty(editedItem.electricity),
          gas: nullToEmpty(editedItem.gas),
          water_supply: nullToEmpty(editedItem.water_supply),
          phone: nullToEmpty(editedItem.phone),
          seating_household: nullToEmpty(editedItem.seating_household),
          seating_capacity: nullToEmpty(editedItem.seating_capacity),
          exit_num: nullToEmpty(editedItem.exit_num)
        });
      }
      // 避難退域時検査場所
      if (facilityClass.isInspection()) {
        Object.assign(payload, {
          arrival_num: nullToEmpty(editedItem.arrival_num),
          bus_num: nullToEmpty(editedItem.bus_num),
          bus_insp_ngnum: nullToEmpty(editedItem.bus_insp_ngnum),
          car_num: nullToEmpty(editedItem.car_num),
          car_insp_ngnum: nullToEmpty(editedItem.car_insp_ngnum),
          congest_situation: nullToEmpty(editedItem.congest_situation)
        });
      }
      // 共通
      Object.assign(payload, {
        lodine_distri_place_flg: editedItem.lodine_distri_place_flg,
        free_input: nullToEmpty(editedItem.free_input)
      });
    }
    /**
     * 行更新または一括更新
     */
    if (saveType.isBulkUpdateOrRowUpdate()) {
      // 避難所
      if (facilityClass.isShelter()) {
        Object.assign(payload, {
          seating_household: nullToEmpty(editedItem.seating_household),
          seating_capacity: nullToEmpty(editedItem.seating_capacity),
          exit_num: nullToEmpty(editedItem.exit_num)
        });
      }
      // 避難退域時検査場所
      if (facilityClass.isInspection()) {
        Object.assign(payload, {
          arrival_num: nullToEmpty(editedItem.arrival_num),
          bus_num: nullToEmpty(editedItem.bus_num),
          bus_insp_ngnum: nullToEmpty(editedItem.bus_insp_ngnum),
          car_num: nullToEmpty(editedItem.car_num),
          car_insp_ngnum: nullToEmpty(editedItem.car_insp_ngnum),
          congest_situation: nullToEmpty(editedItem.congest_situation)
        });
      }
    }

    /**
     * 一括編集
     */
    if (saveType.isBulkEdit()) {
      // 避難所
      if (facilityClass.isShelter()) {
        Object.assign(payload, {
          electricity: nullToEmpty(bulkEditItem.electricity),
          gas: nullToEmpty(bulkEditItem.gas),
          water_supply: nullToEmpty(bulkEditItem.water_supply),
          phone: nullToEmpty(bulkEditItem.phone)
        });
      }
      // 避難退域時検査場所
      if (facilityClass.isInspection()) {
        Object.assign(payload, {
          congest_situation: nullToEmpty(bulkEditItem.congest_situation)
        });
      }
      // 共通
      Object.assign(payload, {
        opening_status: nullToEmpty(bulkEditItem.opening_status),
        opening_date: EvaFacilityStatusTranslator.formatDatetime(
          bulkEditItem.opening_date
        ),
        closing_date: EvaFacilityStatusTranslator.formatDatetime(
          bulkEditItem.closing_date
        )
      });
    }
    return payload;
  }

  static formatDatetime(datetime) {
    const before = config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON;
    const after = config.DATETIME_FORMAT_YYYYMMDDHHMMSS00_WITH_HYPHEN_COLON;
    if (!datetime) {
      return "";
    }
    if (datetime.length === 19) {
      const slashDate = new Date(datetime);
      return moment(slashDate, before).format(after);
    } else {
      const hyphenDate = new Date(datetime);
      return moment(hyphenDate).format(after);
    }
  }
}
